import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const AbvOverUnderScenForm = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.cutoffPeriodId.expr = ExprUtils.and(
      ExprUtils.whereParams('periodicity', 'MON'),
      ExprUtils.isGreaterOrEqual('code', '2023M03'),
    );
    fieldToFieldDef.lbeId.expr = ExprUtils.whereParams('status', 'APPROVED');
    fieldToFieldDef.pipeDayGrpId.expr = ExprUtils.whereParams('status', 'APPROVED');
    fieldToFieldDef.planId.expr = ExprUtils.whereParams('status', 'APPROVED');
    fieldToFieldDef.mcdPymtActualsSplitGrpId.expr = ExprUtils.whereParams('status', 'APPROVED');
    fieldToFieldDef.priceActionPctGrpId.expr = ExprUtils.whereParams('status', 'APPROVED');
  };

  return <EntityForm augFieldDefs={augFieldDefs} />;
};
